import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
export function HomeCTA() {
  return <section className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-1124" data-mp="11zwg22v3jm33">
      <motion.div {...fadeUp} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1125" data-mp="o410o6zwot4g">
        <h2 className="font-heading font-bold text-4xl lg:text-5xl tracking-tight mb-6" data-id="element-1126" data-mp="t2ceestbnnry">
          Build around your organization’s needs
        </h2>
        <p className="text-xl text-white/80 leading-relaxed mb-10" data-id="element-1127" data-mp="1lpyq6ocpdypw">
          Discuss a focused implementation and the workflows you want to improve.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1128" data-mp="17128s0orb9cm">
          <a href="/contact" className="inline-flex items-center justify-center gap-2 bg-white text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1129" data-mp="1bzdlcj6frxyj">
            Contact SyNeural
            <ArrowRight size={18} aria-hidden="true" data-id="element-1130" data-mp="256zezdu5lcw8" />
          </a>
          <a href="/partnerships" className="inline-flex items-center justify-center border border-white/40 text-white hover:bg-white/10 font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1131" data-mp="255enjx34ya2l">
            Explore a Partnership
          </a>
        </div>
      </motion.div>
    </section>;
}